import {observable, action} from 'mobx';
import axiosInstance from '~/utils/axiosInstance';
import {message} from '@enos/dpl';
import localeText from '@locale';
import uris from '~/uris';

export class MenuManagementStore {
  @observable appMenuList;

  @observable currentAppName: string;

  @observable isLoading = false;

  @observable menuAddition;

  @action.bound
  setAppMenuList(data): void {
    this.appMenuList = data;
  }

  @action.bound
  setCurrentAppName(data): void {
    this.currentAppName = data;
  }

  @action.bound
  setLoading(data): void {
    this.isLoading = data;
  }

  @action.bound
  setMenuAddition(data): void {
    this.menuAddition = data;
  }

  @action.bound
  getAppMenuList(body): void {
    this.setLoading(true);
    axiosInstance
      .post(uris.getAppMenuList(), {
        ...body
      })
      .then((data: any) => {
        this.setCurrentAppName(data.appName);
        this.setAppMenuList(data.menus);
        this.setLoading(false);
      })
      .catch(() => {
        this.setLoading(false);
      });
  }

  @action.bound
  getMenuAddition(id): void {
    axiosInstance
      .get(uris.getMenuAddition(), {
        params: {id}
      })
      .then((data: any) => {
        this.setMenuAddition(data);
      });
  }

  @action.bound
  setMenuAdditions(body): Promise<any> {
    return axiosInstance
      .post(uris.setMenuAdditions(), {
        ...body
      });
  }

  @action.bound
  setMenuIcon(body): Promise<any> {
    return axiosInstance
      .post(uris.setMenuIcon(), {
        ...body
      })
      .then(() => {
        message.success(localeText('MENU_MANAGEMENT.MSG_ICON_SAVE_SUCCESSFULLY'));
      });
  }
}

export default new MenuManagementStore();
